import gql from 'graphql-tag';

export const GET_USER_PROFILE = gql `
  query GetUserProfile($userName: String!) {
    currentUserInfoAuth
    companyHasCounty(featureName: "show_county")
    countryForCompany
    agentWordForCompany
    companyHasFeature
    companyHasNewMessages
    companyHasNetworking
    companyBusinessType
    followingUser
    availableStrengths
    availableProducts
    getUser(userName: $userName) {
      id
      user_name
      allowed_name
      fb_user_name
      allowed_phone
      annual_revenue
      assets_under_management
      avg_client_age
      bio
      ask_me_about
      city
      county
      show_city
      amp_trainee_status
      number_of_clients
      profile_picture
      province
      recurring_revenue
      created_at
      headline
      my_rating
      nick_name
      obfuscated
      is_pure_buyer
      is_admin
      designations
      tag_list
      transition_goals
      in_auction
      years_practicing
      number_of_employees
      percent_revenue_recurring
      percent_non_recurring_revenue
      percent_fee_based
      percent_commission
      mix_insurance
      mix_mutual_funds
      mix_annuities
      mix_other
      note_count
      has_team
      visible_profile_features_for_user
      gross_production
      fee_based_revenue
      trailer_revenue
      direct_revenue
      transactional_revenue
      motivation
      planning_preference
      profile_type
      visible_profile_features_for_user
      non_recurring_revenue
      notes {
        id
        comment
        created_at
      }
      business_continuity_state
      languages
      defined_investment_style
      defined_service_model
      part_of_team
      team_size
      niche_market
      expressed_interest
      eoi_consent_state
      incoming_eoi_id
      incoming_eoi_consent_state
      marketplace_visibility_opt_in
      visibility_opted_in_at
      buyer_assessment_result {
        id
        assessmentType
        totalScore
        readinessBand
        bandLabel
        completedAt
        sectionScores
      }
      primary_markets
      specialized_businesses
      why_values
      profile_type
      is_student
      recognition_level
      can_view_partial_sales
      partial_sale_listings {
        id
        sale_status
        created_at
        updated_at
        asking_price
        assets_under_management
        number_of_clients
        fee_based_revenue
        trails_revenue
        direct_revenue
        commission_revenue
        segment_details
        description
        questions
        answers
        states
        client_demographics_details
        services_provided_details
        other_details
        friendly_name
        track_view
        views_count
        interests_count
        current_user_is_an_interest
        user {
          id
          user_name
          allowed_name
          profile_picture
          city
          province
        }
      }
      open_partial_sale_listings {
        id
        sale_status
        created_at
        updated_at
        asking_price
        assets_under_management
        number_of_clients
        fee_based_revenue
        trails_revenue
        direct_revenue
        commission_revenue
        segment_details
        description
        questions
        answers
        states
        client_demographics_details
        services_provided_details
        other_details
        friendly_name
        track_view
        views_count
        interests_count
        current_user_is_an_interest
        user {
          id
          user_name
          allowed_name
          profile_picture
          city
          province
        }
      }
      company {
        id
        name
        use_canadian_retail_wealth_product_mix
        use_p_and_c_product_mix
        hide_product_mix_on_profile
        feature_types
        acquisition_strategy_banner_url
        acquisition_strategy_banner_url_link
        avatar_background_color
        avatar_directory
        primary_color
      }
      product_mix {
        id
        life_ifp
        home_ifp
        auto_ifp
        commercial_ifp
        health_ifp
        group_ifp
        mutual_funds_aum
        securities_aum
        annuities_aua
        segregated_funds_aua
        total_assets
        mcpi_ifp
        private_products_ifp
        crop_hail_ifp
        crop_hail_with_wind_ifp
        farm_insurance_ifp
        price_products_ifp
        replant_supplement_ifp
        gic_fixed_income
        equity
      }
      affiliations {
        id
        name
      }
      conversation_with_me {
        id
      }
      # RJ Seller Visibility — server-computed branch for the seller's Meeting Room
      # actions. Shared with ChatPanel so the two surfaces cannot disagree; the
      # drawer must not re-derive it from motivation as it used to.
      rj_meeting_room_invite_state {
        branch
        deal_id
        workflow_state
        deals { id name }
      }
      is_in_deal_past_out_for_receiving_signature_state
      inventory_user {
        id
        deal_interest_for_current_user {
          id
          workflow_state
          invited
          saved
          shortlisted
          proposal
          proposal_letter
          receiving_party_nda_sent_timestamp
          conversation_id
          reason_for_suggestion
          q1
          q2
          q3
          q4
          q5
          a1
          a2
          a3
          a4
          a5
          deal {
            id
            headline
            deal_name
            deal_state
            closed
            sub_headline
            summary_of_business
            ideal_candidate
          }
          deal_scheduled_meetings {
            id
            start_time
            duration
            format
          }
          documents {
            id
            name
            download_url
            category
            uploaded_by {
              name
            }
            created_at
            mime_type
          }
        }
      }
    }
    getCurrentUser {
      id
      user_name
      name
      locale
      roles
      has_selling_transition_goals
      planning_preference
      limited_access
      is_fb_subscriber
      talent_acquisition_user
      omit
      motivation
      profile_type
      planning_preference
      visible_profile_features_for_user
      company {
        id
        name
        stylesheet_name
        seller_only_label
        ratings
        enabled_student_profiles
        student_word
        search_amp_trainee
        student_program_title
        business_type
        allow_scheduling_in_deal_room
        deal_room_allow_messaging_when_shortlisted
        deal_room_branded_name
        deal_room_branded_name_fr
        deal_room_single_word
        deal_room_single_word_fr
        feature_types
      }
      inventory_user {
        id
        deal_interests {
          id
          workflow_state
          deal {
            id
            deal_name
            headline
          }
        }
      }
    }
    company {
      id
      name
      country
      business_type
      features
      enabled_student_profiles
      student_word
      search_amp_trainee
      student_program_title
      use_canadian_retail_wealth_product_mix
      use_p_and_c_product_mix
      hide_product_mix_on_profile
      feature_types
      acquisition_strategy_banner_url
      acquisition_strategy_banner_url_link
      avatar_background_color
      avatar_directory
      primary_color
    }
  }
`;

export const CREATE_CHAT = gql `
  mutation createChat($userName: String!) {
    createChat(userName: $userName) {
      id
    }
  }
`;